module.exports = __webpack_public_path__ + "img/iphone-3.2b1c57ef.jpeg";